import React from 'react'
import { OrganizationMemberFromContext } from '~/core/context/organization/hooks/useOrganizationMembers'
import { Toolbox } from '~/plugins/toolbox/shared'
import { UIChatItem, UIChatReaction, UIChatThread } from '../types'
import { RenderMessage } from './RenderMessage'

const getEmojiError = (item: UIChatItem) => {
  const options: UIChatReaction[] = ['🙇', '😞']

  const index = Toolbox.Utility.stringToRandomNumber(
    item.id,
    0,
    options.length - 1,
  )

  return options[index] ?? options[0]
}

type Props = {
  item: UIChatItem
  organizationMember: OrganizationMemberFromContext
  thread: UIChatThread
  onReaction: (reaction: UIChatReaction) => void
  onOpenThread?: () => void
  onAskForHelp?: () => void
  onDelete?: () => Promise<void>
  onSend?: (item: UIChatItem) => Promise<void>
}

export const RenderMessageAgent: React.FC<Props> = ({
  item,
  organizationMember,
  thread,
  onReaction,
  onOpenThread,
  onAskForHelp = () => {},
  onSend,
  onDelete,
}) => {
  return (
    <>
      <RenderMessage
        item={item}
        organizationMember={organizationMember}
        thread={thread}
        onOpenThread={onOpenThread}
        onReaction={onReaction}
        onAskForHelp={onAskForHelp}
        onSend={onSend}
        onDelete={onDelete}
      />
    </>
  )
}
